import { useCallback, useState } from 'react'
import { LocationEditorFieldConfig, LocationEditorFieldValue } from '../types'
import { useConnectDropDownToLocationPin } from './useConnectDropDownToLocationPin'
import { useConnectFormFieldToLocationPin } from './useConnectFormFieldToLocationPin'
import { useConnectLocationPinToFormField } from './useConnectLocationPinToFormField'
import { useInitializeFormFieldLocationPin } from './useInitializeFormFieldLocationPin'
import { useLocationActions } from './useLocationActions'
import { useRemoveLocationPinOnLeaving } from './useRemoveLocationPinOnLeaving'
import { useSearchOnMapItems } from './useSearchOnMapItems'

type OnChange = (value: LocationEditorFieldValue) => void

export function useLocationEditorField(
  props: LocationEditorFieldConfig,
  value: LocationEditorFieldValue,
  onChange: OnChange,
) {
  const { pinId, queryMinLength = 3 } = props
  const [loading, setLoading] = useState(() => false)

  const { onFixInvalidAddress, onConfirmLowAccuracy } = useLocationActions(pinId)

  const { assets, onTextChange, clearAssetList } = useSearchOnMapItems(
    { ...props, queryMinLength },
    setLoading,
  )

  const getLocation = () => value

  const onClose = useCallback(() => {
    clearAssetList()
    setLoading(false)
  }, [clearAssetList])

  useInitializeFormFieldLocationPin(props, value)
  useRemoveLocationPinOnLeaving(pinId)

  useConnectFormFieldToLocationPin(props)
  useConnectLocationPinToFormField(props, value, onChange)

  const onSelectAsset = useConnectDropDownToLocationPin(props)

  return {
    queryMinLength,
    loading,
    onSelectAsset,
    assets,
    onTextChange,
    onFixInvalidAddress,
    onConfirmLowAccuracy,
    onClose,
    getLocation,
    setLoading,
  }
}
